<template>
    <Modal @shown="shown" @hidden="hidden" ref="modal" modalClass="modal-md" @submit="submit">
        <template #title>
            <template v-if="localUser && !readonly">
                {{ i18n('Edit {name}').replace('{name}', i18n('User')) }}
            </template>
            <template v-else-if="localUser">
                {{ i18n('{name} Detail').replace('{name}', i18n('User')) }}
            </template>
            <template v-else>
                {{ i18n('Add {name}').replace('{name}', i18n('User')) }}
            </template>
        </template>

        <div class="alert alert-danger mb-2" v-if="errorMessage">{{ errorMessage }}</div>

        <div class="row g-2">
            <div class="col-12">
                <Field v-model="formData.provider" :errorMessage="errorMessages.provider" :label="i18n('Provider')"
                    :disabled="submitted || !!localUser" :required="true" :type="readonly ? 'readonly' : 'dictionary'"
                    rest="providers" format="object" />
            </div>
            <div class="col-12 col-sm-6">
                <Field v-model="formData.first_name" :errorMessage="errorMessages.first_name"
                    :label="i18n('First Name')" :disabled="submitted" :type="readonly ? 'readonly' : 'text'" />
            </div>
            <div class="col-12 col-sm-6">
                <Field v-model="formData.last_name" :errorMessage="errorMessages.last_name" :label="i18n('Last Name')"
                    :disabled="submitted" :type="readonly ? 'readonly' : 'text'" />
            </div>
            <div class="col-12">
                <Field v-model="formData.document" :errorMessage="errorMessages.document" :label="i18n('Document')"
                    :disabled="submitted" :required="true" :type="readonly ? 'readonly' : 'text'" />
            </div>
            <div class="col-12">
                <Field v-model="formData.email" :errorMessage="errorMessages.email" :label="i18n('Email')"
                    :disabled="submitted" :required="true" :type="readonly ? 'readonly' : 'email'" />
            </div>
        </div>

        <template #footer>
            <div class="row">
                <template v-if="!readonly">
                    <div class="col text-start">
                        <button type="button" class="btn btn-danger" @click="hide">
                            {{ i18n('Cancel') }}
                        </button>
                    </div>
                    <div class="col text-end">
                        <button type="submit" class="btn btn-primary text-white" :disabled="submitted">
                            {{ i18n('Confirm') }}
                        </button>
                    </div>
                </template>
                <div class="col text-end" v-else>
                    <button type="button" @click="hide" class="btn btn-outline-dark btn-sm me-2">
                        {{ i18n('Close') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import api from "@/api.js";
import { duplicate, } from "@/tools/object.js";
import Modal from "@/components/common/layout/Modal.vue";
import Field from "@/components/common/form/Field.vue";
import { translatedErrorMessage, } from "@/tools/errorHandling.js";

export default {
    components: {
        Modal,
        Field,
    },
    data() {
        return {
            localUserId: null,
            localUser: null,
            submitted: false,
            formData: {},
            errorMessages: {},
            errorMessage: '',
        };
    },
    emits: [
        'shown',
        'hidden',
        'created',
        'updated',
    ],
    computed: {
        readonly() {
            return this.localUser
                && this.localUser.acl?.update !== true;
        },
    },
    methods: {
        show(localUserId) {
            this.localUserId = localUserId;
            this.localUser = null;
            this.load().then(() => {
                this.submitted = false;
                this.$refs['modal'].show();
                this.errorMessages = {};
                this.errorMessage = '';

                if (this.localUser) {
                    this.formData = duplicate(this.localUser);
                } else {
                    this.formData = {};
                }
            });
        },
        load() {
            if (!this.localUserId) return Promise.resolve();
            let promise = api.get(`localUsers/${this.localUserId}`, { acl: 'localUser' });

            promise.then(localUser => {
                this.localUser = localUser;
            });

            return promise;
        },
        hide() {
            this.$refs['modal'].hide();
        },
        shown() {
            this.$emit('shown');
        },
        hidden() {
            this.$emit('hidden');
        },
        submit() {
            this.submitted = true;
            this.errorMessages = {};
            this.errorMessage = '';

            const postFormData = duplicate(this.formData);

            if (this.formData.email) {
                this.formData.email = this.formData.email.trim().toLowerCase();
            }
            let savePromise;

            if (!this.localUser) {
                savePromise = api.post(`localUsers`, postFormData);
            } else {
                savePromise = api.put(`localUsers/${this.localUser.id}`, postFormData);
            }

            savePromise.then(localUser => {
                if (!this.localUser) {
                    this.$emit('created', localUser);
                } else {
                    this.$emit('updated', localUser);
                }

                this.hide();
            }).catch((errorMessage) => {
                this.errorMessage = translatedErrorMessage(errorMessage);
                this.submitted = false;
            });
        }
    }
}
</script>